export const DATOS_INSTRUCCIONES_EMPLEADOS = [
  {
    campo: 'Nombres',
    tipoDato: 'Texto',
    descripcion: 'Nombres del empleado',
    formatoValido: 'Texto, máximo hasta 40 caracteres',
    ejemploValido: 'Juan Carlos',
    ejemploInvalido:
      'Ejemplo de texto muy largo de prueba para validador de datos',
    opcionesPermitidas: '',
    observaciones: 'Ingresar un valor menor a 40 caracteres',
  },
  {
    campo: 'Primer apellido',
    tipoDato: 'Texto',
    descripcion: 'Primer apellido del empleado',
    formatoValido: 'Texto, máximo hasta 30 caracteres',
    ejemploValido: 'Doe',
    ejemploInvalido:
      'Ejemplo de texto muy largo de prueba para validador de datos',
    opcionesPermitidas: '',
    observaciones: 'Ingresar un valor menor a 30 caracteres',
  },
  {
    campo: 'Segundo apellido',
    tipoDato: 'Texto',
    descripcion: 'Segundo apellido del empleado',
    formatoValido: 'Texto, máximo hasta 30 caracteres',
    ejemploValido: 'Doe',
    ejemploInvalido:
      'Ejemplo de texto muy largo de prueba para validador de datos',
    opcionesPermitidas: '',
    observaciones: 'Campo opcional, ingresar un valor menor a 30 caracteres',
  },
  {
    campo: 'Tipo de documento',
    tipoDato: 'Texto',
    descripcion: 'Sigla del tipo de documento',
    formatoValido: 'CC\nTI\nRC\nCE\nPEP\nNIT\nPA\nPPT',
    ejemploValido: 'CC',
    ejemploInvalido: 'Cedula',
    opcionesPermitidas: 'CC\nTI\nRC\nCE\nPEP\nNIT\nPA\nPPT',
    observaciones:
      'Cédula Ciudadanía\nTarjeta Identidad\nRegistro Civil\nCédula Extranjería\nPermiso Especial Permanencia\nNúmero Identificación Tributaria\nPasaporte\nPermiso por protección temporal',
  },
  {
    campo: 'Número de documento',
    tipoDato: 'Numérico',
    descripcion: 'Número del documento del empleado',
    formatoValido: 'Solo números',
    ejemploValido: '123456789',
    ejemploInvalido: '1.234.567-89',
    opcionesPermitidas: '',
    observaciones: 'Sin puntos, guiones ni espacios',
  },
  {
    campo: 'Cargo',
    tipoDato: 'Texto',
    descripcion: 'Cargo del empleado',
    formatoValido: 'Texto, máximo hasta 70 caracteres',
    ejemploValido: 'Analista de sistemas Junior',
    ejemploInvalido:
      'Ejemplo de texto muy largo de prueba para validador de datos en una celda de excel',
    opcionesPermitidas: '',
    observaciones: 'Ingresar un valor menor a 70 caracteres',
  },
  {
    campo: 'Fecha de ingreso',
    tipoDato: 'Fecha',
    descripcion: 'Fecha de ingreso del empleado',
    formatoValido: 'dd/mm/aaaa',
    ejemploValido: '15/1/2024',
    ejemploInvalido: '01-15-2026',
    opcionesPermitidas: '',
    observaciones: 'Usar formato día/mes/año',
  },
  {
    campo: 'Fecha de contrato hasta',
    tipoDato: 'Fecha',
    descripcion: 'Fecha fin de contrato',
    formatoValido: 'dd/mm/aaaa',
    ejemploValido: '15/1/2026',
    ejemploInvalido: '01-15-2026',
    opcionesPermitidas: '',
    observaciones:
      'Usar formato día/mes/año<br>Si el empleado no tiene fecha de finalización de contrato, deje la celda en blanco',
  },
  {
    campo: 'Teléfono',
    tipoDato: 'Numérico',
    descripcion: 'Número telefónico del empleado',
    formatoValido: 'Solo números',
    ejemploValido: '3001234567',
    ejemploInvalido: '+57 300 123 4567',
    opcionesPermitidas: '',
    observaciones: 'Sin espacios ni caracteres especiales',
  },
  {
    campo: 'Salario',
    tipoDato: 'Numérico',
    descripcion: 'Salario del empleado',
    formatoValido: 'Valor numérico entero',
    ejemploValido: '2000000',
    ejemploInvalido: '$2.000000',
    opcionesPermitidas: '',
    observaciones:
      'Sin símbolos ni separadores<br>Para los tipos de contrato OPS, se debe calcular el promedio de las últimas dos cuentas de cobro o facturas dentro de un lapso de tres meses.',
  },
  {
    campo: 'Tipo de contrato',
    tipoDato: 'Texto',
    descripcion: 'Tipo de contrato laboral',
    formatoValido: 'Texto definido',
    ejemploValido: 'Término indefinido',
    ejemploInvalido: 'Indefinido',
    opcionesPermitidas:
      'Término indefinido<br>Término Fijo<br>OPS<br>Aprendizaje',
    observaciones: 'Seleccionar una opción válida',
  },
  {
    campo: 'Embargo',
    tipoDato: 'Texto',
    descripcion: 'Indica si el empleado tiene embargo',
    formatoValido: 'Texto definido',
    ejemploValido: 'Sí',
    ejemploInvalido: 'Embargado',
    opcionesPermitidas: 'Sí, No',
    observaciones: 'Seleccionar una opción válida',
  },
  {
    campo: '¿Insolvente legalmente?',
    tipoDato: 'Texto',
    descripcion: 'Indica si el empleado se encuentra en estado de insolvencia',
    formatoValido: 'Texto definido',
    ejemploValido: 'Sí',
    ejemploInvalido: 'Insolvente',
    opcionesPermitidas: 'Sí, No',
    observaciones: 'Seleccionar una opción válida',
  },
  {
    campo: 'Otras deducciones Salario',
    tipoDato: 'Numérico',
    descripcion: 'Monto de otras deducciones de salario',
    formatoValido: 'Valor numérico entero',
    ejemploValido: '200000',
    ejemploInvalido: '$200.000,00',
    opcionesPermitidas: '',
    observaciones:
      'Sin símbolos ni separadores. Se deben excluir las deducciones por créditos de libranza con la financiera del grupo empresarial',
  },
  {
    campo: 'Cantidad llamados atención',
    tipoDato: 'Numérico',
    descripcion: 'Cantidad de llamados de atención',
    formatoValido: 'Número entero',
    ejemploValido: '2',
    ejemploInvalido: 'Dos',
    opcionesPermitidas: '',
    observaciones: 'Solo números enteros',
  },
  {
    campo: 'Evaluación desempeño',
    tipoDato: 'Numérico',
    descripcion: 'Evaluación del desempeño',
    formatoValido: 'Escala de 0 a 100',
    ejemploValido: '20',
    ejemploInvalido: 'Excelente',
    opcionesPermitidas: 'Número de 0 a 100',
    observaciones: 'Debe estar dentro del rango permitido',
  },
  {
    campo: 'Monto máximo cuota',
    tipoDato: 'Numérico',
    descripcion: 'Monto máximo permitido para cuota',
    formatoValido: 'Valor numérico entero',
    ejemploValido: '5000000',
    ejemploInvalido: '500.000',
    opcionesPermitidas: '',
    observaciones: 'Sin símbolos ni separadores',
  },
  {
    campo: 'Días vacaciones disponibles',
    tipoDato: 'Numérico',
    descripcion: 'Días de vacaciones disponibles',
    formatoValido: 'Número entero',
    ejemploValido: '15',
    ejemploInvalido: '15 días',
    opcionesPermitidas: '',
    observaciones: 'Solo números enteros',
  },
  {
    campo: 'Frecuencia de pago',
    tipoDato: 'Texto',
    descripcion: 'Frecuencia de pago del salario',
    formatoValido: 'Texto definido',
    ejemploValido: 'Mensual',
    ejemploInvalido: 'cada mes',
    opcionesPermitidas: 'Mensual, Quincenal',
    observaciones: 'Seleccionar una opción válida',
  },
  {
    campo: 'Tipo de cuenta bancaria',
    tipoDato: 'Texto',
    descripcion: 'Tipo de cuenta bancaria del empleado',
    formatoValido: 'Texto definido',
    ejemploValido: 'Ahorros',
    ejemploInvalido:
      'Ejemplo de texto muy largo de prueba para el validador de datos',
    opcionesPermitidas: 'Corriente<br>Ahorros<br>Fiducia<br>Vista',
    observaciones: '',
  },
  {
    campo: 'Entidad bancaria',
    tipoDato: 'Texto',
    descripcion: 'Entidad bancaria de la cuenta de nómina del empleado',
    formatoValido: 'Texto definido',
    ejemploValido: 'BANCO BBVA S.A.S',
    ejemploInvalido: 'Otro valor',
    opcionesPermitidas: 'Listado de bancos Hoja ListadoBancos',
    observaciones: 'Seleccionar una opción válida',
  },
  {
    campo: 'Número de cuenta bancaria',
    tipoDato: 'Texto',
    descripcion: 'Número de cuenta bancaria del empleado',
    formatoValido: 'Texto, máximo hasta 34 caracteres',
    ejemploValido: '654321',
    ejemploInvalido: '',
    opcionesPermitidas: '',
    observaciones: 'Ingresar un valor menor a 34 caracteres',
  },
];

export const CAMPOS_LISTA = [
  {
    key: 'tipoDocumento',
    formulae: '"CC,TI,RC,CE,PEP,NIT,PA,PPT"',
  },
  {
    key: 'tipoContrato',
    formulae: '"Término indefinido,Termino Fijo,OPS,Aprendizaje"',
  },
  {
    key: 'embargo',
    formulae: '"Sí,No"',
  },
  {
    key: 'esInsolvente',
    formulae: '"Sí,No"',
  },
  {
    key: 'frecuenciaPago',
    formulae: '"Mensual,Quincenal"',
  },
  {
    key: 'tipoCuentaBancaria',
    formulae: '"Corriente,Ahorros,Fiducia,Vista"',
  },
  {
    key: 'entidadBancaria',
    formulae: 'ListadoBancos!$B$4:$B$500',
  },
];

export const DATOS_INSTRUCCIONES_NOVEDADES = [
  {
    campo: 'Número de documento',
    tipoDato: 'Numérico',
    descripcion:
      'Número de documento del empleado al que se le reporta la novedad',
    formatoValido: 'Solo números',
    ejemploValido: '123456789',
    ejemploInvalido: '1.234.567-89',
    opcionesPermitidas: '',
    observaciones: 'Sin puntos, guiones ni espacios',
  },
  {
    campo: 'Tipo de novedad',
    tipoDato: 'Texto',
    descripcion: 'Tipo de novedad',
    formatoValido: 'Texto definido',
    ejemploValido: 'Licencia no remunerada',
    ejemploInvalido: 'Opción diferente',
    opcionesPermitidas:
      'Licencia no remunerada<br>Suspensión<br>Ausencia no justificada<br>Descuento por responsabilidad',
    observaciones: 'Seleccionar una opción válida',
  },
  {
    campo: 'Fecha inicio',
    tipoDato: 'Fecha',
    descripcion: 'Fecha de inicio de la novedad',
    formatoValido: 'dd/mm/aaaa',
    ejemploValido: '15/01/2024',
    ejemploInvalido: '01-15-2026',
    opcionesPermitidas: '',
    observaciones: 'Usar formato día/mes/año',
  },
  {
    campo: 'Fecha fin',
    tipoDato: 'Fecha',
    descripcion: 'Fecha de finalización de la novedad',
    formatoValido: 'dd/mm/aaaa',
    ejemploValido: '15/01/2024',
    ejemploInvalido: '01-15-2026',
    opcionesPermitidas: '',
    observaciones: 'Usar formato día/mes/año',
  },
  {
    campo: 'Observación',
    tipoDato: 'Texto',
    descripcion: 'Observación de la novedad',
    formatoValido: 'Texto, máximo hasta 255 caracteres',
    ejemploValido:
      'Se suspende el empleado por falta al reglamento organizacional',
    ejemploInvalido:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis,.',
    opcionesPermitidas: '',
    observaciones: 'Ingresar un valor menor a 255 caracteres',
  },
];

export const construirCamposListaNovedades = tiposNovedades => [
  {
    key: 'tipoNovedad',
    formulae: `"${tiposNovedades
      .map(({ descripcion }) => descripcion)
      .join(',')}"`,
  },
];
